import { FC, ReactNode } from "react";
import { Spin } from "../Spin/Spin";

import "./CustomButton.scss";

interface IProps {
    children: ReactNode;
    onClick?: (event?: any) => void;
    className?: string;
    style?: object;
    loading?: boolean;
    disabled?: boolean;
    outline?: boolean;
    isSmall?: boolean;
    isDefault?: boolean;
    isCancel?: boolean;
    isRound?: boolean;
}

export const CustomButton: FC<IProps> = ({
                                             children,
                                             className = '',
                                             loading = false,
                                             onClick,
                                             style,
                                             disabled = false,
                                             outline = false,
                                             isSmall = false,
                                             isDefault = false,
                                             isCancel = false,
                                             isRound = false
                                         }) => {
    let _className = "communication-button__primary";

    if (outline) {
        _className = "communication-button__outline-primary";
    }
    
    if (isDefault) {
        _className = "communication-button__default";
    }
    
    if (isCancel) {
        _className = "communication-button__cancel";
    }

    if (disabled || loading) {
        _className = "communication-button__disabled";
        if (outline) {
            _className = "communication-button__outline-primary-disabled";
        }
        if (isDefault) {
            _className = "communication-button__default-disabled";
        }
        if (isCancel) {
            _className = "communication-button__cancel-disabled";
        }
    }
    
    if (isSmall) {
        _className += " communication-button_small"
    }
    
    if (isRound) {
        _className += " communication-button_round"
    }

    return (
        <div
            onClick={(event?: any) => !disabled && !loading && onClick && onClick(event)}
            className={"communication-button " + _className + " " + className}
            style={style}
        >
            {loading &&
                <div>
                    <Spin small={true}/>
                </div>
            }
            {children}
        </div>
    );
};
